export default __webpack_public_path__ + "static/media/Background_00127.a44f221b.png";